import { render, staticRenderFns } from "./TableCompanyGroup.vue?vue&type=template&id=1e2160ae&scoped=true"
import script from "./TableCompanyGroup.vue?vue&type=script&lang=js"
export * from "./TableCompanyGroup.vue?vue&type=script&lang=js"
import style0 from "./TableCompanyGroup.vue?vue&type=style&index=0&id=1e2160ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2160ae",
  null
  
)

export default component.exports